/* eslint-disable react/prop-types */
import { createContext, useState, useContext } from 'react';
import Backdrop from '@mui/material/Backdrop';
import FancyBackdropLoader from './FancyBackdropLoader.component';

const BackdropContext = createContext();

export const useBackdrop = () => useContext(BackdropContext);

export const BackdropProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('Loading...');

  const showBackdrop = (customMessage = 'Loading...') => {
    setMessage(customMessage);
    setOpen(true);
  };
  const hideBackdrop = () => setOpen(false);

  return (
    <BackdropContext.Provider value={{ showBackdrop, hideBackdrop }}>
      {children}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 999,
          background: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(4px)',
        }}
        open={open}
      >
        <FancyBackdropLoader message={message} />
      </Backdrop>
    </BackdropContext.Provider>
  );
};
